import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster, TooltipProvider } from 'design-system';
import { CookiesProvider } from 'react-cookie';
import { Provider as ReduxStoreProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { useImpostorRefresh } from '@/features/auth-access';
import { AddToAppContextProvider } from '@/features/dashboard/state/AppContext';
import { GlobalLoaderProvider } from '@/providers/GlobalLoaderProvider';
import { useFeatureFlagRefresh } from '@/services/feature-flags/useFeatureFlagRefresh';
import { SnackbarNotificationsProvider } from '@/shared/hooks/snackbarNotifications.context';

import { store } from '@/store';
import { router } from './routes';

const queryClient = new QueryClient();

const AppRuntime: React.FC = () => {
  useImpostorRefresh();
  useFeatureFlagRefresh();

  return <RouterProvider router={router} />;
};

const App: React.FC = () => {
  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <ReduxStoreProvider store={store}>
            <AddToAppContextProvider>
              <Toaster limit={5}>
                <GlobalLoaderProvider>
                  <SnackbarNotificationsProvider>
                    <AppRuntime />
                  </SnackbarNotificationsProvider>
                </GlobalLoaderProvider>
              </Toaster>
            </AddToAppContextProvider>
          </ReduxStoreProvider>
        </TooltipProvider>
        <div className='fixed top-1/2 right-3 z-[var(--z-floating-anchor)] -mt-5'>
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition='relative'
          />
        </div>
      </QueryClientProvider>
    </CookiesProvider>
  );
};

export default App;
